var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./Dispatchers.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4639fe3e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Dispatchers.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Dispatchers/Dispatchers.vue
// module id = 397
// module chunks = 1